import response from 'axios'
import CryptoJS from 'crypto-js'
import { ref } from 'vue'
const res = await fetch('/config.json')
const config = ref({})
config.value = await res.json()
// response.defaults.baseURL = 'https://api.9seapi.vip'
// response.defaults.baseURL = 'https://62api.500ad.vip' //https://api.9seapi.vip
response.defaults.baseURL = config.value.domain || 'https://u.wseuirwoerlkwddnlksd.com' //https://api.9seapi.vip
// import router from '@/router'

// 添加请求拦截器
response.interceptors.request.use(
  function (config) {
    // if (config.method === 'get') {
    //   console.log(config.params, 'config.params')

    //   // 确保 params 存在
    //   config.params = {
    //     ...config.params,
    //     s: signature,
    //     t: timestamp
    //   }
    // }
    // // 请求头添加token
    // const token = sessionStorage.getItem('userinfo')
    //   ? JSON.parse(sessionStorage.getItem('userinfo')).token
    //   : ''
    // const lang = sessionStorage.getItem('lang') ? sessionStorage.getItem('lang') : 'en'
    // // console.log(token)
    // console.log(config, 'config')
    // if (token) {
    //   config.headers['token'] = token
    // }
    // 获取当前时间戳
    // let currentTime = new Date().getTime()
    // console.log(config.url, 'config')

    const parts = ['bt', '!nQ', 'e4', 'a$', 'ef', 'w3', 'zZ', 'K2']
    const secureKey =
      parts[0] + parts[3] + parts[1] + parts[5] + parts[2] + parts[7] + parts[4] + parts[6]
    const timestamp = Date.now().toString()
    // const signature = CryptoJS.HmacSHA256(timestamp, secureKey).toString()
    const signature = CryptoJS.HmacSHA256(timestamp, secureKey).toString(CryptoJS.enc.Hex)
    if (config.url == '/v1/api/getconfig' || config.url.includes('/v1/api/getconfig')) {
      let lastModified = localStorage.getItem('lastModified') || '1'
      config.headers['If-Modified-Since'] = lastModified
    }

    config.headers['X-Time'] = timestamp
    config.headers['X-Sign'] = signature

    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
response.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么

    // console.log(response.headers.get('last-modified'), 'response.headers')
    const lastModified = response.headers.get('last-modified')
    if (lastModified) {
      localStorage.setItem('lastModified', lastModified)
    }

    // console.log(data, '1111')

    return response.data.data
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    // console.log(error.response.status)
    // if (error.response.data.code == 401) {
    //   router.replace('/login')
    // }

    return error.response.status
    // return JSON.parse(localStorage.getItem('data'))
  }
)

export default response
